// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
// @ts-ignore
import { selectCurrentSeasonId } from 'services/currentSeasonId/selectors';
// @ts-ignore
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';

const selectLoadSprayEventsForSubmissionParams = createDeepEqualSelector(
    [selectCurrentOrganizationId, selectCurrentSeasonId, selectCurrentEntityId],
    (
        currentOrganizationIdState: string | undefined,
        currentSeasonIdState: number | undefined,
        currentEntityIdState: number | undefined
    ) => ({
        organizationId: currentOrganizationIdState,
        filter: {
            eager: '[sprayEvent.[sprayEntities, cropSureDetails,sprayEventOperations]]',
            fields: [
                'id',
                'startDate',
                'endDate',
                'entityName',
                'entityId',
                'sprayEvent.id',
                'sprayEvent.applicationType',
                'sprayEvent.isReadyToSubmit',
                'sprayEvent.isFinalSpray',
                'sprayEvent.sprayEntities.id',
                'sprayEvent.cropSureDetails.blocks'
            ],
            require: {
                $and: [
                    {
                        'schema.eventTypeId': 'SPRAY',
                        'sprayEvent.isReadyToSubmit': true,
                        deletedAt: { $exists: false },
                        ...(currentSeasonIdState
                            ? { 'entity.seasonId': currentSeasonIdState }
                            : {}),
                        $and: [
                            ...(currentEntityIdState
                                ? [
                                      {
                                          $or: [
                                              {
                                                  'entity.path': {
                                                      $or: [
                                                          {
                                                              $like: `/${currentEntityIdState}/%`
                                                          },
                                                          {
                                                              $equals: `/${currentEntityIdState}`
                                                          }
                                                      ]
                                                  }
                                              },
                                              {
                                                  entityId: currentEntityIdState
                                              }
                                          ]
                                      }
                                  ]
                                : [])
                        ]
                    }
                ]
            }
        }
    })
);

export { selectLoadSprayEventsForSubmissionParams };
